// ════════════════════════════════════════════════════════════════════════════
//  features/fiscal/types/index.ts
// ════════════════════════════════════════════════════════════════════════════

// ── CFOP ──────────────────────────────────────────────────────────────────

export interface CfopListagemDto {
  id:          number;
  codigo:      string | null;
  descricao:   string | null;
  calculaIcms: boolean;
  dtVigencia:  string | null;
}

export interface CfopComboDto {
  id:       number;
  codigo:   string | null;
  descricao: string | null;
}

export interface CfopDto {
  id:             number;
  codigo:         string | null;
  descricao:      string | null;
  calculaIcms:    boolean;
  dtVigencia:     string | null;
  grupoCfopId:    number;
  subgrupoCfopId: number;
  cstAceito:      string | null;
  cstPis:         string | null;
  cstCofins:      string | null;
  informacaoFisco: string | null;
}

export interface SalvarCfopRequest {
  codigo:         string | null;
  descricao:      string | null;
  calculaIcms:    boolean;
  dtVigencia:     string | null;
  grupoCfopId:    number;
  subgrupoCfopId: number;
  cstAceito:      string | null;
  cstPis:         string | null;
  cstCofins:      string | null;
  informacaoFisco: string | null;
}

// ── CSOSN (Simples Nacional) ──────────────────────────────────────────────

export interface CsosnComboDto {
  id:            number;
  codigoCsosn:   number;
  descricao:     string | null;
}

// ── CEST ──────────────────────────────────────────────────────────────────

export interface CestListagemDto {
  id:        number;
  codigo:    string | null;
  descricao: string | null;
  segmento:  string | null;
  codigoNcm: string | null;
  anexo:     string | null;
}

export interface CestComboDto {
  id:        number;
  codigo:    string | null;
  descricao: string | null;
}

export interface CestDto {
  id:        number;
  codigo:    string | null;
  descricao: string | null;
  segmento:  string | null;
  codigoNcm: string | null;
  anexo:     string | null;
}

export interface SalvarCestRequest {
  codigo:    string | null;
  descricao: string | null;
  segmento:  string | null;
  codigoNcm: string | null;
  anexo:     string | null;
}

export interface ImportarCestResultado {
  inseridos:   number;
  atualizados: number;
  erros:       number;
}

export interface ImportarNcmResultado {
  inseridos:   number;
  atualizados: number;
  erros:       number;
  total:       number;
}

// ── CBenef — Código de Benefício Fiscal ───────────────────────────────────

export interface CBenefListagemDto {
  id:            number;
  cbenef:        string;
  uf:            string;
  produtoId:     number;
  produtoNome:   string | null;
  regraFiscalId: number;
  cstId:         number | null;
}

export interface CBenefDto {
  id:            number;
  cbenef:        string;
  uf:            string;
  produtoId:     number;
  regraFiscalId: number;
  cstId:         number | null;
}

export interface SalvarCBenefRequest {
  cbenef:        string;
  uf:            string;
  produtoId:     number;
  regraFiscalId: number;
  cstId:         number | null;
}

// ── CST ICMS ──────────────────────────────────────────────────────────────

export interface CstIcmsListagemDto {
  id:        number;
  cst:       string | null;
  descricao: string | null;
  tipoCst:   number;
}

export interface CstIcmsComboDto { id: number; cst: string | null; descricao: string | null; }

export interface CstIcmsDto {
  id:                      number;
  cst:                     string | null;
  descricao:               string | null;
  tipoCst:                 number;
  indIbsCbs:               boolean;
  indIbsCbsMono:           boolean;
  indReducao:              boolean;
  indDiferimento:          boolean;
  indTransferenciaCredito: boolean;
  indCredPresIbsZfm:       boolean;
  indAjusteCompetencia:    boolean;
  indRedutorBc:            boolean;
}

export interface SalvarCstIcmsRequest {
  cst:                     string | null;
  descricao:               string | null;
  tipoCst:                 number;
  indIbsCbs:               boolean;
  indIbsCbsMono:           boolean;
  indReducao:              boolean;
  indDiferimento:          boolean;
  indTransferenciaCredito: boolean;
  indCredPresIbsZfm:       boolean;
  indAjusteCompetencia:    boolean;
  indRedutorBc:            boolean;
}

// ── CSOSN — full CRUD types ────────────────────────────────────────────────

export interface CsosnListagemDto {
  id:           number;
  codigoCsosn:  number;
  descricao:    string | null;
}

export interface CsosnDto {
  id:               number;
  codigoCsosn:      number;
  descricao:        string | null;
  textoExplicativo: string | null;
}

export interface SalvarCsosnRequest {
  codigoCsosn:      number;
  descricao:        string | null;
  textoExplicativo: string | null;
}

// ── ANP ───────────────────────────────────────────────────────────────────

export interface AnpListagemDto {
  id:               number;
  codigo:           string | null;
  descricaoProduto: string | null;
  isCombustivel:    boolean;
  percentualMix:    number | null;
}

export interface AnpDto {
  id:               number;
  codigo:           string | null;
  descricaoProduto: string | null;
  isCombustivel:    boolean;
  percentualMix:    number | null;
}

export interface SalvarAnpRequest {
  codigo:           string | null;
  descricaoProduto: string | null;
  isCombustivel:    boolean;
  percentualMix:    number | null;
}

// ── NcmIcmsPartilha (FCP) ─────────────────────────────────────────────────

export interface NcmIcmsPartilhaListagemDto {
  id:               number;
  codigoNcm:        string | null;
  uf:               string | null;
  aliqFcp:          number | null;
  aliqInterestadual: number | null;
}

export interface NcmIcmsPartilhaDto {
  id:               number;
  codigoNcm:        string | null;
  uf:               string | null;
  aliqInterestadual: number | null;
  aliqEstadoDestino: number | null;
  aliqFcp:           number | null;
  partilhaDestino:   number | null;
  aliqTotalDestino:  number | null;
  partilhaRemetente: number | null;
  diferencial:       number | null;
}

export interface SalvarNcmIcmsPartilhaRequest {
  codigoNcm:        string | null;
  uf:               string | null;
  aliqInterestadual: number | null;
  aliqEstadoDestino: number | null;
  aliqFcp:           number | null;
  partilhaDestino:   number | null;
  aliqTotalDestino:  number | null;
  partilhaRemetente: number | null;
  diferencial:       number | null;
}

// ── NCM ───────────────────────────────────────────────────────────────────

export interface NcmListagemDto {
  codigoInterno: number;
  codigo:        string;
  descricao:     string;
  isAtivo:       boolean;
  isMonofasico:  boolean;
  usaCest:       boolean;
  dataInicio:    string;
  dataFim:       string;
}

export interface NcmDto {
  codigo:      string;
  descricao:   string;
  isAtivo:     boolean;
  isMonofasico: boolean;
  usaCest:     boolean;
  dataInicio:  string;
  dataFim:     string;
}

export interface SalvarNcmRequest {
  codigo:      string;
  descricao:   string;
  isAtivo:     boolean;
  isMonofasico: boolean;
  usaCest:     boolean;
  dataInicio:  string;
  dataFim:     string;
}

// ── CST PIS/COFINS ────────────────────────────────────────────────────────

export interface CstPisCofinsListagemDto {
  id:             number;
  codigoImposto:  number;
  cst:            string | null;
  descricao:      string | null;
}

export interface CstPisCofinsComboDto { id: number; cst: string | null; descricao: string | null; }

// ── Natureza de Operação ──────────────────────────────────────────────────

export interface NaturezaOperacaoListagemDto {
  id:                  number;
  descricao:           string | null;
  movimentaFinanceiro: boolean;
  movimentaEstoque:    boolean;
  isInativo:           boolean;
  /** A nota com esta natureza entra nos relatórios de vendas. */
  contaComoVenda?:     boolean;
}

export interface NaturezaOperacaoComboDto { id: number; descricao: string | null; }

export interface NaturezaOperacaoDto {
  id: number;
  descricao:           string | null;
  movimentaFinanceiro: boolean;
  movimentaEstoque:    boolean;
  forcarCfop:          boolean;
  isInativo:           boolean;
  // CSTs
  cstSaida:            string | null;
  cstEntrada:          string | null;
  csosn:               string | null;
  cstPisCofinsaida:    string | null;
  cstPisCofinsEntrada: string | null;
  // CFOPs Saída
  cfopSaida:              number | null;
  cfopSaidaNaoContrib:    number | null;
  cfopSaidaUf:            number | null;
  cfopSaidaUfNaoContrib:  number | null;
  cfopSaidaExterior:      number | null;
  cfopSaidaContaForaConta: number | null;
  // CFOPs Entrada
  cfopEntrada:            number | null;
  cfopEntradaUf:          number | null;
  cfopEntradaExterior:    number | null;
  // CFOPs ST/Devolução
  cfopSaidaStInterna:         number | null;
  cfopSaidaStInterestadual:   number | null;
  cfopEntradaStInterna:       number | null;
  cfopEntradaStInterestadual: number | null;
  tipoNfDebito:  number;
  tipoNfCredito: number;
  /** A nota com esta natureza entra nos relatórios de vendas. */
  contaComoVenda?: boolean;
}

export interface SalvarNaturezaOperacaoRequest {
  descricao:           string;
  movimentaFinanceiro: boolean;
  movimentaEstoque:    boolean;
  /** A nota com esta natureza entra nos relatórios de vendas. */
  contaComoVenda:      boolean;
  forcarCfop:          boolean;
  isInativo:           boolean;
  cstSaida:            string;
  cstEntrada:          string;
  csosn:               string;
  cstPisCofinsaida:    string;
  cstPisCofinsEntrada: string;
  cfopSaida:              number | null;
  cfopSaidaNaoContrib:    number | null;
  cfopSaidaUf:            number | null;
  cfopSaidaUfNaoContrib:  number | null;
  cfopSaidaExterior:      number | null;
  cfopSaidaContaForaConta: number | null;
  cfopEntrada:            number | null;
  cfopEntradaUf:          number | null;
  cfopEntradaExterior:    number | null;
  cfopSaidaStInterna:         number | null;
  cfopSaidaStInterestadual:   number | null;
  cfopEntradaStInterna:       number | null;
  cfopEntradaStInterestadual: number | null;
  tipoNfDebito:  number;
  tipoNfCredito: number;
}

// ── Regra Fiscal ──────────────────────────────────────────────────────────

export interface RegraFiscalListagemDto {
  id:                 number;
  ncmId:              number;
  ncmCodigo:          string | null;
  cfopId:             number;
  cfopCodigo:         string | null;
  naturezaOperacaoId: number | null;
  ufDestino:          string | null;
  aliqIcms:           number | null;
  isAtivo:            boolean;
}

export interface RegraFiscalDto {
  id: number;
  ncmId:               number;
  cfopId:              number;
  naturezaOperacaoId:  number | null;
  naturezaReceitaId:   number | null;
  crtId:               number | null;
  ufDestino:           string | null;
  cstIcmsId:           number | null;
  csosnId:             number | null;
  origemId:            number | null;
  modBcIcms:           number | null;
  aliqIcms:            number | null;
  redBcIcms:           number | null;
  aliqIcmsSt:          number | null;
  mvaSt:               number | null;
  fcp:                 number | null;
  cstPisId:            number | null;
  cstCofinsId:         number | null;
  aliqPis:             number | null;
  aliqCofins:          number | null;
  cstIpiId:            number | null;
  aliqIpi:             number | null;
  cClassTribId:        number | null;
  aliqCbs:             number | null;
  aliqIbsUf:           number | null;
  observacao:          string | null;
  isAtivo:             boolean;
}

export interface SalvarRegraFiscalRequest {
  ncmId:               number;
  cfopId:              number;
  naturezaOperacaoId:  number | null;
  naturezaReceitaId:   number | null;
  crtId:               number | null;
  ufDestino:           string;
  cstIcmsId:           number | null;
  csosnId:             number | null;
  origemId:            number | null;
  modBcIcms:           number | null;
  aliqIcms:            number | null;
  redBcIcms:           number | null;
  aliqIcmsSt:          number | null;
  mvaSt:               number | null;
  fcp:                 number | null;
  cstPisId:            number | null;
  cstCofinsId:         number | null;
  aliqPis:             number | null;
  aliqCofins:          number | null;
  cstIpiId:            number | null;
  aliqIpi:             number | null;
  cClassTribId:        number | null;
  aliqCbs:             number | null;
  aliqIbsUf:           number | null;
  observacao:          string;
  isAtivo:             boolean;
}

// ── CClass Tributária (IBS/CBS) ───────────────────────────────────────────

export interface CClassTribListagemDto {
  id:               number;
  codCClassTrib:    string;
  nome:             string;
  perRedIbs:        number;
  perRedCbs:        number;
  dtInicioVigencia: string | null;
  dtFimVigencia:    string | null;
}

export interface CClassTribComboDto { id: number; codCClassTrib: string; nome: string; }

export interface CClassTribDto {
  id:            number;
  codCClassTrib: string;
  nome:          string;
  descricao:     string | null;
  lcRedacao:     string | null;
  leiDecreto:    string | null;
  tipoAliquota:  number;
  perRedIbs:     number;
  perRedCbs:     number;
  // Indicadores tributação
  indTribRegular:      boolean;
  indCreditoPresumido: boolean;
  indMonofasico:       boolean;
  indMonoRetencao:     boolean;
  indMonoRetido:       boolean;
  indMonoDiferido:     boolean;
  indEstornoCredito:   boolean;
  // Documentos habilitados
  indNFe:   boolean;
  indNFCe:  boolean;
  indCTe:   boolean;
  indCTeOS: boolean;
  indBPe:   boolean;
  indNF3e:  boolean;
  indNFCom: boolean;
  indNFSe:  boolean;
  // Vigência
  dtInicioVigencia: string | null;
  dtFimVigencia:    string | null;
  anexo:            string | null;
  linkLei:          string | null;
  creditoPara:      string | null;
}

export interface SalvarCClassTribRequest {
  codCClassTrib: string;
  nome:          string;
  descricao:     string;
  lcRedacao:     string;
  leiDecreto:    string;
  tipoAliquota:  number;
  perRedIbs:     number;
  perRedCbs:     number;
  indTribRegular:      boolean;
  indCreditoPresumido: boolean;
  indMonofasico:       boolean;
  indMonoRetencao:     boolean;
  indMonoRetido:       boolean;
  indMonoDiferido:     boolean;
  indEstornoCredito:   boolean;
  indNFe:   boolean;
  indNFCe:  boolean;
  indCTe:   boolean;
  indCTeOS: boolean;
  indBPe:   boolean;
  indNF3e:  boolean;
  indNFCom: boolean;
  indNFSe:  boolean;
  dtInicioVigencia: string | null;
  dtFimVigencia:    string | null;
  anexo:       string;
  linkLei:     string;
  creditoPara: string;
}

// ── Monofásico PIS/COFINS ─────────────────────────────────────────────────

export interface MonofasicoListagemDto {
  id:                number;
  codigoNcm:         string | null;
  segmentoAtividade: number;
  regimeTributacao:  number;
  tributacao:        string | null;
  cstPis:            string | null;
  aliqPis:           number;
  aliqCofins:        number;
  grupoBeneficiado:  string | null;
}

export interface MonofasicoDto {
  id:                   number;
  codigoNcm:            string | null;
  segmentoAtividade:    number;
  regimeTributacao:     number;
  tributacao:           string | null;
  cstPis:               string | null;
  cstCofins:            string | null;
  aliqPis:              number;
  aliqCofins:           number;
  aliquotaCondicionada: boolean;
  condicoes:            string | null;
  vigencia:             string | null;
  novoNcm:              string | null;
  dtInicioVigencia:     string | null;
  dtFimVigencia:        string | null;
  grupoBeneficiado:     string | null;
  origemInformacao:     string | null;
  baseLegal:            string | null;
  observacoes:          string | null;
}

export interface SalvarMonofasicoRequest {
  codigoNcm:            string | null;
  segmentoAtividade:    number;
  regimeTributacao:     number;
  tributacao:           string | null;
  cstPis:               string | null;
  cstCofins:            string | null;
  aliqPis:              number;
  aliqCofins:           number;
  aliquotaCondicionada: boolean;
  condicoes:            string | null;
  vigencia:             string | null;
  novoNcm:              string | null;
  dtInicioVigencia:     string | null;
  dtFimVigencia:        string | null;
  grupoBeneficiado:     string | null;
  origemInformacao:     string | null;
  baseLegal:            string | null;
  observacoes:          string | null;
}

// ── Correlação CFOP/CST ───────────────────────────────────────────────────

export interface CorrelacaoCfopCstListagemDto {
  id:        number;
  cstSaida:  string | null;
  descricao: string | null;
  isInativo: boolean;
}

export interface CorrelacaoCfopCstDto {
  id:        number;
  cstSaida:  string | null;
  descricao: string | null;
  csosnId:   number;
  isInativo: boolean;
  cfopSaida:              number;
  cfopSaidaNaoContrib:    number;
  cfopSaidaUf:            number;
  cfopSaidaUfNaoContrib:  number;
  cfopSaidaExterior:      number;
  cfopSaidaContaForaConta: number;
  cfopEntrada:            number;
  cfopEntradaUf:          number;
  cfopEntradaExterior:    number;
}

export interface SalvarCorrelacaoCfopCstRequest {
  cstSaida:  string;
  descricao: string;
  csosnId:   number;
  isInativo: boolean;
  cfopSaida:              number;
  cfopSaidaNaoContrib:    number;
  cfopSaidaUf:            number;
  cfopSaidaUfNaoContrib:  number;
  cfopSaidaExterior:      number;
  cfopSaidaContaForaConta: number;
  cfopEntrada:            number;
  cfopEntradaUf:          number;
  cfopEntradaExterior:    number;
}

// ── Classificação Fiscal (cad_ncm_clas_fiscal / cad_ncm_clas_fiscal_uf) ───

export interface ClassificacaoFiscalListagemDto {
  id:                    number;
  ncmId:                 number;
  ncmCodigo:             string | null;
  ncmDescricao:          string | null;
  codigoNcmComplemento:  string | null;
  cClassTribId:          number;
  incidePisCofins:       boolean;
  incideIpi:             boolean;
  isMonofasico:          boolean;
}

export interface ClassificacaoFiscalUfDto {
  id:                   number;
  ncmId:                number;
  classificacaoFiscalId: number;
  uf:                   string | null;
  modDeterminacaoBC:    number | null;
  reducaoBcIcms:        number | null;
  aliqIcms:             number | null;
  bcOperacaoPropria:    number | null;
  destacarIcms:         boolean;
  modDeterminacaoBCSt:  number | null;
  reducaoBcSt:          number | null;
  aliqIcmsSt:           number | null;
  margemValorSt:        number | null;
  aliqIcmsAproveitado:  number | null;
  tributacaoIcms:       string | null;
  situacaoTributariaId: number | null;
  csosnId:              number | null;
  precoBaseSubs:        number | null;
  aliqCbs:              number;
  aliqIbsUf:            number;
  aliqIbsMunicipio:     number;
  motivoDesoneracao:    string | null;
  cBnef:                string | null;
  naturezaOperacaoId:   number | null;
}

export interface ClassificacaoFiscalDto {
  id:                    number;
  ncmId:                 number;
  codigoNcmComplemento:  string | null;
  cClassTribId:          number;
  cestId:                string | null;
  anpId:                 number | null;
  origemId:              number | null;
  isMonofasico:          boolean;
  destacarIcmsST:        boolean;
  incideIpi:             boolean;
  incidePisCofins:       boolean;
  produtoEspecifico:     boolean;
  cfopSaida:             number;
  cfopSaidaNaoContrib:   number;
  cfopSaidaUf:           number;
  cfopSaidaUfNaoContrib: number;
  cfopSaidaExterior:     number;
  cfopSaidaContaForaConta: number;
  cfopEntrada:           number;
  cfopEntradaUf:         number;
  cfopEntradaExterior:   number;
  cstPisCofinsEntradaId: number | null;
  cstPisCofinsaidasId:   number | null;
  naturezaReceitaId:     number | null;
  ipiCstEntradaId:       number | null;
  ipiCstSaidaId:         number | null;
  aliqIpi:               number | null;
  aliqCbs:               number;
  aliqIbsUf:             number;
  aliqIbsMunicipio:      number;
  cstId:                 number | null;
  descAnp:               string | null;
  codAnp:                string | null;
  anpCodif:              string | null;
  anpVPart:              number | null;
  anpPGNi:               number | null;
  anpPGNn:               number | null;
  anpPGLP:               number | null;
  perPisCofinsEntrada:   number | null;
  perPisCofinsaida:      number | null;
  codEnquadramentoIpi:   string | null;
  percTributosInformado: number | null;
  observacao:            string | null;
  itensUf:               ClassificacaoFiscalUfDto[];
}

export interface SalvarClassificacaoFiscalUfRequest {
  uf:                   string | null;
  modDeterminacaoBC:    number | null;
  reducaoBcIcms:        number | null;
  aliqIcms:             number | null;
  bcOperacaoPropria:    number | null;
  destacarIcms:         boolean;
  modDeterminacaoBCSt:  number | null;
  reducaoBcSt:          number | null;
  aliqIcmsSt:           number | null;
  margemValorSt:        number | null;
  aliqIcmsAproveitado:  number | null;
  tributacaoIcms:       string | null;
  situacaoTributariaId: number | null;
  csosnId:              number | null;
  precoBaseSubs:        number | null;
  aliqCbs:              number;
  aliqIbsUf:            number;
  aliqIbsMunicipio:     number;
  motivoDesoneracao:    string | null;
  cBnef:                string | null;
  naturezaOperacaoId:   number | null;
}

export interface SalvarClassificacaoFiscalRequest {
  ncmId:                  number;
  codigoNcmComplemento:   string | null;
  cClassTribId:           number;
  cestId:                 string | null;
  anpId:                  number | null;
  origemId:               number | null;
  isMonofasico:           boolean;
  destacarIcmsST:         boolean;
  incideIpi:              boolean;
  incidePisCofins:        boolean;
  produtoEspecifico:      boolean;
  cfopSaida:              number;
  cfopSaidaNaoContrib:    number;
  cfopSaidaUf:            number;
  cfopSaidaUfNaoContrib:  number;
  cfopSaidaExterior:      number;
  cfopSaidaContaForaConta: number;
  cfopEntrada:            number;
  cfopEntradaUf:          number;
  cfopEntradaExterior:    number;
  cstPisCofinsEntradaId:  number | null;
  cstPisCofinsaidasId:    number | null;
  naturezaReceitaId:      number | null;
  ipiCstEntradaId:        number | null;
  ipiCstSaidaId:          number | null;
  aliqIpi:                number | null;
  aliqCbs:                number;
  aliqIbsUf:              number;
  aliqIbsMunicipio:       number;
  cstId:                  number | null;
  descAnp:                string | null;
  codAnp:                 string | null;
  anpCodif:               string | null;
  anpVPart:               number | null;
  anpPGNi:                number | null;
  anpPGNn:                number | null;
  anpPGLP:                number | null;
  perPisCofinsEntrada:    number | null;
  perPisCofinsaida:       number | null;
  codEnquadramentoIpi:    string | null;
  percTributosInformado:  number | null;
  observacao:             string | null;
  itensUf:                SalvarClassificacaoFiscalUfRequest[];
}

// ── Nota Fiscal ───────────────────────────────────────────────────────────

export type StatusNFe = 'emitida' | 'cancelada' | 'denegada' | 'pendente' | 'inutilizada';

export interface NotaFiscalResumoDto {
  id:                  number;
  operacaoId:          number;
  numeroNota:          number;
  serie:               string | null;
  chaveNota:           string | null;
  cStat:               string | null;
  xMotivo:             string | null;
  protocolo:           string | null;
  dtSituacao:          string;
  clienteId:           number | null;
  isAmbienteProducao:  boolean;
  dtCriacao:           string;
  /** Data de emissão da nota (a que vai no XML). */
  dtEmissao?:          string | null;
  /** Destinatário/remetente da nota. */
  nomeRazao:           string | null;
  totalNota:           number;
  situacao:            'rascunho' | 'autorizada' | 'rejeitada' | 'cancelada' | 'inutilizada';
  /** Emitida em outro sistema e importada pelo XML: não se cancela nem se corrige por aqui. */
  isImportada?:        boolean;
  /** 55 (NF-e) ou 65 (NFC-e). */
  modelo?:              number | null;
  /** Destinatário gravado na nota (mesmo valor de nomeRazao). */
  nomeDestinatario?:    string | null;
  cnpjCpfDestinatario?: string | null;
}

/** Filtros server-side de GET /api/notas-fiscais. */
export interface FiltrosNotaFiscal {
  dtInicio?:    string;
  dtFim?:       string;
  busca?:       string;
  serie?:       string;
  /** emitida | pendente | cancelada | inutilizada | denegada (vazio/'todos' = todas). */
  situacao?:    StatusNFe | 'todos' | string;
  /** Sinônimo de situacao (nome da tela da paridade). */
  status?:      StatusNFe;
  /** 55 (padrão do servidor), 65, ou 0 = os dois. */
  modelo?:      55 | 65 | 0;
  ordenarPor?:  'emissao' | 'numero';
  decrescente?: boolean;
}

export interface NotaFiscalContadoresDto {
  emitidas: number; pendentes: number; canceladas: number; denegadas: number; inutilizadas?: number;
}

// ── Importação das NF-e emitidas em outro sistema ────────────────────────────

export interface NfeImportacaoOcorrencia {
  arquivo:  string;
  chave:    string | null;
  numero:   number | null;
  /** recusada | ignorada | aviso */
  situacao: string;
  codigo:   string;
  mensagem: string;
}

export interface NfeImportacaoMes {
  mes:             string;   // yyyy-MM
  notas:           number;
  canceladas:      number;
  total:           number;
  totalCanceladas: number;
}

export interface NfeImportacaoResultado {
  /** "Só conferir": nada foi gravado; os números são o que a importação faria. */
  simulacao:          boolean;
  arquivosLidos:      number;
  notasLidas:         number;
  eventosLidos:       number;
  repetidosNoEnvio:   number;
  importadas:         number;
  jaExistentes:       number;
  canceladas:         number;
  recusadas:          number;
  eventosRegistrados: number;
  clientesCriados:    number;
  produtosCriados:    number;
  titulosGerados:     number;
  totalTitulos:       number;
  totalImportado:     number;
  porMes:             NfeImportacaoMes[];
  /** Naturezas da operação que não estavam no cadastro ("TEXTO — conta como venda" / "— fora das vendas"). */
  naturezasNovas:     string[];
  clientesNovos:      string[];
  produtosNovos:      string[];
  ocorrencias:        NfeImportacaoOcorrencia[];
}

export interface NotaFiscalEventoDto {
  id:          number;
  tipoEvento:  number | null;
  cStat:       string | null;
  xMotivo:     string | null;
  protocolo:   number | null;
  dtSituacao:  string;
  /** Texto da correção, nas cartas de correção. */
  texto?:      string | null;
  /** Há XML do evento (procEventoNFe) guardado para baixar. */
  temXml?:     boolean;
}

export interface NotaFiscalDetalheDto extends NotaFiscalResumoDto {
  numeroLote:              number | null;
  cnpj:                    string | null;
  codigoSituacao:          number | null;
  descricaoSituacao:       string | null;
  protocoloCancelamento:   string | null;
  versao:                  string | null;
  tipoDocFiscal:           number | null;
  dtAtualizacao:           string;
  eventos:                 NotaFiscalEventoDto[];
  /** True quando o XML autorizado está guardado e pode ser baixado. */
  temXml:                  boolean;
}

export interface PaginadoResponseNFe<T> {
  itens:         T[];
  total:         number;
  pagina:        number;
  tamanhoPagina: number;
  totalPaginas:  number;
  /** Só em GET /api/notas-fiscais: contagem por situação do filtro inteiro. */
  contadores?:   NotaFiscalContadoresDto;
}

export interface TransmitirNotaRequest { empresaId?: number; }
export interface CancelarNotaRequest {
  justificativa: string;
  empresaId?: number;
  /** Estorna também o pedido que a nota faturou (estoque, títulos a receber e comissão). */
  estornarPedido?: boolean;
}

export interface TransmitirNotaResponse {
  sucesso:   boolean;
  cStat:     string;
  xMotivo:   string;
  protocolo: string | null;
  chaveNota: string | null;
  /** O que o usuário precisa saber além do retorno da SEFAZ (ex.: resultado do estorno do pedido). */
  aviso?:    string | null;
  /** Títulos/boletos/e-mail disparados pela autorização (forma com boleto automático). */
  posAutorizacao?: NfePosAutorizacao | null;
}

// ── Criação de NF-e ───────────────────────────────────────────────────────

/** Local de entrega da mercadoria, quando diferente do endereço do destinatário. */
export interface NotaEntregaInput {
  nome?:              string | null;
  cnpjCpf?:           string | null;
  inscricaoEstadual?: string | null;
  endereco?:          string | null;
  numero?:            string | null;
  complemento?:       string | null;
  bairro?:            string | null;
  cidade?:            string | null;
  uf?:                string | null;
  cep?:               string | null;
  fone?:              string | null;
}

export interface NotaAnaliticaItemRequest {
  produtoId:      number;
  subProdutoId?:  number;
  descricao?:     string;
  /** Informações adicionais do item (infAdProd), até 500 caracteres. */
  infAdicional?:  string | null;
  ncm?:           string;
  cfop:           string;
  cst?:           string;
  csosn?:         string;
  unidade?:       string;
  quantidade:     number;
  valorUnitario:  number;
  desconto:       number;
  baseIcms:       number;
  aliqIcms:       number;
  valorIcms:      number;
  baseIcmsSt:     number;
  icmsSt:         number;
  difalDest:      number;
  difalOrig:      number;
  fcp:            number;
  valorIpi:       number;
  aliqPis:        number;
  valorPis:       number;
  aliqCofins:     number;
  valorCofins:    number;
  valorIbs:       number;
  valorCbs:       number;
  valorIs:        number;
  valorAproxTributos: number;
  /** pRedBC — % de redução da base do ICMS (CST 20/70/90), vindo do cálculo do backend. */
  percRedBcIcms?: number;
  /** Bases de PIS/COFINS (veículo usado = margem). Ausente/0 = valor do item. */
  basePis?:       number;
  baseCofins?:    number;
}

/** POST /api/fiscal/tributacao/calcular-item — cálculo do item no backend (motor do Desktop). */
export interface CalculoItemRequest {
  produtoId:           number;
  notaSaida:           boolean;
  ufCliente:           string;
  consumidorFinal:     boolean;
  clienteContribuinte: boolean;
  quantidade:          number;
  valorUnitario:       number;
  desconto?:           number;
  cfop?:               string;
}

export interface CalculoItemResultado {
  cfop: string; cst: string | null; csosn: string | null;
  valorProduto: number; valorTotalItem: number;
  baseIcms: number; aliqIcms: number; valorIcms: number; percRedBcIcms: number; valorIcmsDesonerado: number;
  baseIcmsSt: number; aliqIcmsSt: number; valorIcmsSt: number;
  baseIpi: number; aliqIpi: number; valorIpi: number;
  basePis: number; aliqPis: number; valorPis: number;
  baseCofins: number; aliqCofins: number; valorCofins: number;
  fcp: number; difalDest: number; difalOrig: number; valorAproxTributos: number;
  ehVeiculoUsado: boolean; margem: number | null; custoAquisicao: number | null;
  fonteCusto: 'RENAVE' | 'CUSTO_MEDIO' | null; codigoBeneficioFiscal: string | null;
}

export interface CriarNotaFiscalRequest {
  naturezaOperacao:   string;
  tipoDocFiscal:      number;
  numeroNota:         number;
  serie?:             string;
  dtMovimento:        string;
  dtEmissao:          string;
  dtSaida:            string;
  clienteId:          number;
  nomeRazao?:         string;
  cnpjCpf?:           string;
  endereco?:          string;
  bairro?:            string;
  cep?:               string;
  cidade?:            string;
  /** Código IBGE do município (vem do endereço do cliente). Sem ele o servidor procura pelo nome da cidade na UF. */
  cidadeIbge?:        number | null;
  numero?:            string;
  uf?:                string;
  inscricaoEstadual?: string;
  tipoNota:           number;   // 1=Saída, 2=Entrada (convenção ITipoNota do desktop)
  tipoFrete:          number;
  isConsumidorFinal:  boolean;
  indicadorPresenca:  number;
  finalidadeId:       number;
  isAmbienteProducao: boolean;
  valorFrete:         number;
  valorSeguro:        number;
  valorDesconto:      number;
  /** Outras despesas (vOutro) — o acréscimo do pedido vem aqui. A tela só exibe e reenvia. */
  valorAcessorios?:   number | null;
  /** Chaves (44 dígitos) das NF-e referenciadas — devolução e complementar. */
  chavesReferenciadas?: string[] | null;
  obsContrib?:        string;
  obsFisco?:          string;
  /** Local de entrega; ausente ou sem logradouro = entrega no endereço do destinatário. */
  entrega?:           NotaEntregaInput | null;
  transporte?:        NotaTransporteInput;
  volumes?:           NotaVolumeInput[];
  formasPagamento?:   NotaPagamentoInput[];
  /** Parcelas de cobrança (boleto). */
  duplicatas?:        NotaDuplicataInput[];
  /** E-mail do destinatário (recebe NF-e e boleto). */
  email?:             string;
  itens:              NotaAnaliticaItemRequest[];
}

export interface NotaTransporteInput {
  nomeTransportadora?:     string;
  cnpjTransportadora?:     string;
  inscricaoEstadualTransp?: string;
  enderecoTransp?:         string;
  cidadeTransp?:           string;
  ufTransp?:               string;
  placaVeiculo?:           string;
  ufVeiculo?:              string;
  rntc?:                   string;
}

export interface NotaVolumeInput {
  quantidade:   number;
  especie?:     string;
  marca?:       string;
  pesoLiquido?: number;
  pesoBruto?:   number;
}

export interface NotaPagamentoInput {
  formaPagamento: string;
  nomePagamento?: string;
  valor:          number;
  /** Forma do CADASTRO: é ela que liga "Gerar boleto automático" na autorização. */
  formaPagRecId?: number | null;
}

/** Parcela de cobrança da nota: vira duplicata no XML e título a receber. */
export interface NotaDuplicataInput {
  parcela:        number;
  dtVencimento:   string;
  valor:          number;
  formaPagRecId?: number | null;
}

/** Códigos tPag que geram cobrança a prazo (boleto, duplicata, crédito loja). */
export const TPAG_COBRANCA = ['15', '14', '05'];

export interface NfeBoletoDaNota {
  contaReceberId: number;
  parcela:        number;
  valor:          number;
  dtVencimento:   string;
  nossoNumero:    string | null;
  situacao:       string | null;
  linhaDigitavel: string | null;
}

/** Títulos, boletos e e-mail disparados pela autorização (OK, ERRO, NAO_APLICAVEL, PENDENTE). */
export interface NfePosAutorizacao {
  notaId:         number;
  titulos:        string;
  boletos:        string;
  email:          string;
  emailDestino:   string | null;
  dtEmailEnviado: string | null;
  mensagem:       string | null;
  boletosDaNota:  NfeBoletoDaNota[];
}

export const FORMAS_PAGAMENTO_NFE = [
  { codigo: '01', descricao: 'Dinheiro' },
  { codigo: '02', descricao: 'Cheque' },
  { codigo: '03', descricao: 'Cartão de Crédito' },
  { codigo: '04', descricao: 'Cartão de Débito' },
  { codigo: '05', descricao: 'Crédito em Loja' },
  { codigo: '10', descricao: 'Vale Alimentação' },
  { codigo: '11', descricao: 'Vale Refeição' },
  { codigo: '12', descricao: 'Vale Presente' },
  { codigo: '13', descricao: 'Vale Combustível' },
  { codigo: '14', descricao: 'Duplicata Mercantil' },
  { codigo: '15', descricao: 'Boleto Bancário' },
  { codigo: '16', descricao: 'Depósito Bancário' },
  { codigo: '17', descricao: 'PIX' },
  { codigo: '18', descricao: 'Transferência Bancária' },
  { codigo: '90', descricao: 'Sem Pagamento' },
  { codigo: '99', descricao: 'Outros' },
] as const;

/** GET /api/notas-fiscais/inutilizacoes/contexto */
export interface InutilizacaoFaixaContexto {
  /** Falso quando não há serviço fiscal ou a empresa não é emitente. */
  disponivel: boolean;
  /** Ambiente do emitente: é nele que a faixa será inutilizada. */
  producao: boolean;
  serie: number;
  motivo: string | null;
  maximoPorFaixa: number;
  /** Menor número aceito: 1 em produção; em homologação, o início da faixa de teste. */
  numeroMinimo?: number;
}

export interface InutilizarFaixaRequest {
  serie: number;
  numeroInicial: number;
  numeroFinal: number;
  justificativa: string;
  /** O ambiente que a tela mostrou; a API recusa se o emitente estiver em outro. */
  producao: boolean;
}

export interface InutilizacaoFaixaResultado {
  sucesso: boolean;
  cStat: string;
  xMotivo: string;
  protocolo: string | null;
  numerosRegistrados: number;
}

/** GET /api/notas-fiscais/{id}/conteudo — o que a nota contém (conferência do rascunho). */
export interface NotaFiscalConteudo {
  id: number;
  naturezaOperacao: string | null;
  /** Nº do pedido de venda que originou a nota, quando houver. */
  pedido: string | null;
  podeDescartar: boolean;
  /** Nota nunca autorizada com número reservado: o número pode ser inutilizado na SEFAZ. */
  podeInutilizar: boolean;
  /** Nota ainda não autorizada (rascunho ou rejeitada): pode ser reaberta e editada. */
  podeEditar: boolean;
  /** Pontos que não impedem a transmissão mas costumam ser engano (ex.: frete com valor e "Sem frete"). */
  avisos?: string[];
  /** Nota de pedido ainda não autorizada (rascunho ou rejeitada): pode ser refeita com o cadastro atual. */
  podeAtualizarDoPedido: boolean;
  destinatario: {
    nome: string | null; cpfCnpj: string | null; inscricaoEstadual: string | null; email: string | null;
    endereco: string | null; numero: string | null; bairro: string | null; cidade: string | null;
    uf: string | null; cep: string | null; cidadeIbge: number | null; consumidorFinal: boolean;
  };
  itens: {
    item: number; produtoId: number; descricao: string | null; ncm: string | null; cfop: string | null;
    csosn: string | null; cst: string | null; unidade: string | null; quantidade: number;
    valorUnitario: number; valorTotal: number; desconto: number;
  }[];
  pagamentos: { forma: string | null; valor: number }[];
  duplicatas: { parcela: number; vencimento: string; valor: number }[];
  lotes: { produtoId: number; lote: string | null; fabricacao: string | null; validade: string | null; quantidade: number }[];
  totais: { produtos: number; desconto: number; outrasDespesas: number; nota: number };
  observacao: string | null;
}

export interface NotaFiscalRascunhoCriado {
  id:             number;
  operacaoId:     number;
  numeroNota:     number;
  serie:          string | null;
  totalItens:     number;
  totalProdutos:  number;
  dtCriacao:      string;
}

// ── Tributação ────────────────────────────────────────────────────────────

export interface TributacaoRequest {
  produtoId:          number;
  empresaId?:         number;
  notaSaida?:         boolean;
  ufEmpresa?:         string;
  ufCliente?:         string;
  consumidorFinal?:   boolean;
  forcarCfop?:        boolean;
  usarIbsCbs?:        boolean;
  clienteContribuinte?: boolean;
}

export interface TributacaoResponse {
  produtoId:              number;
  descricao:              string | null;
  ncm:                    string | null;
  origem:                 string;
  cfopAplicado:           number;
  cstAplicado:            string | null;
  csosn:                  string | null;
  icmsAliquota:           number;
  perRedBCICMS:           number;
  perICMSSt:              number;
  perMvaSt:               number;
  perICMSDiferido:        number;
  perICMSCreditoSimples:  number;
  aliqInterEstadual:      number;
  aliqICMSUfDestino:      number;
  aliqFcp:                number;
  incideIpi:              boolean;
  perIpi:                 number;
  incidePisCofins:        boolean;
  pisCstSaida:            string | null;
  cofinsCstSaida:         string | null;
  pisAliquota:            number;
  cofinsAliquota:         number;
  incideIBSCBS:           boolean;
  cstIBSCBS:              string | null;
  aliqIBSUF:              number;
  aliqIBSMun:             number;
  aliqCBS:                number;
}

// ── Resumo de Impostos ────────────────────────────────────────────────────

export interface ImpostosResumo {
  totalIcms:    number;
  totalIcmsSt:  number;
  totalIpi:     number;
  totalPis:     number;
  totalCofins:  number;
  totalDifal:   number;
  totalFcp:     number;
  totalIbs:     number;
  totalCbs:     number;
  totalBruto:   number;
  totalNotas:   number;
}

/** Deriva o status front-end a partir do cStat retornado pela API. */
export function statusDeCStat(cStat: string | null): StatusNFe {
  if (!cStat || cStat === '0') return 'pendente';
  if (cStat === '100')         return 'emitida';
  if (cStat === '101' || cStat === '135' || cStat === '155') return 'cancelada';
  if (cStat === '102')         return 'inutilizada';   // número inutilizado na SEFAZ
  if (cStat === '110' || cStat === '301' || cStat === '302') return 'denegada';
  return 'pendente';
}

// ── Tabela UF ICMS — Alíquotas interestaduais ─────────────────────────────

export interface TabUfIcmsDto {
  ufOrigem:  string | null;
  ac: number; al: number; am: number; ap: number; ba: number; ce: number;
  df: number; es: number; go: number; ma: number; mg: number; ms: number;
  mt: number; pa: number; pb: number; pe: number; pi: number; pr: number;
  rj: number; rn: number; ro: number; rr: number; rs: number; sc: number;
  se: number; sp: number; to: number;
  perIcmsSt: number;
  perFcp:    number;
  perFcpSt:  number;
}

export interface SalvarTabUfIcmsRequest {
  ac: number; al: number; am: number; ap: number; ba: number; ce: number;
  df: number; es: number; go: number; ma: number; mg: number; ms: number;
  mt: number; pa: number; pb: number; pe: number; pi: number; pr: number;
  rj: number; rn: number; ro: number; rr: number; rs: number; sc: number;
  se: number; sp: number; to: number;
  perIcmsSt: number;
  perFcp:    number;
  perFcpSt:  number;
}

// ── NFC-e (modelo 65) — EMISSÃO ───────────────────────────────────────────
//  A configuração da NFC-e (CSC/série/numeração) usa os tipos de
//  features/configuracoes (ConfigNfce / AtualizarConfigNfceRequest).

export interface NfceItemRequest {
  produtoId:          number;
  subProdutoId?:      number;
  descricao:          string;
  ncm:                string;
  cfop:               string;
  cst?:               string;
  csosn?:             string;
  unidade:            string;
  quantidade:         number;
  valorUnitario:      number;
  desconto:           number;
  baseIcms:           number;
  aliqIcms:           number;
  valorIcms:          number;
  aliqPis:            number;
  valorPis:           number;
  aliqCofins:         number;
  valorCofins:        number;
  valorAproxTributos: number;
}

export interface NfcePagamentoRequest {
  formaPagamento: string;     // "01"=Dinheiro, "03"=Crédito, "04"=Débito, "17"=PIX...
  nomePagamento?: string;
  valor:          number;
}

export interface EmitirNfceRequest {
  empresaId?:                number;
  cpfCnpjConsumidor?:        string;
  nomeConsumidor?:           string;
  emailConsumidor?:          string;
  indicadorPresenca?:        number;       // default 1 (presencial)
  indicadorIntermediador?:   number;       // default 0
  naturezaOperacao?:         string;       // default "VENDA AO CONSUMIDOR FINAL"
  valorFrete:                number;
  valorSeguro:               number;
  valorDesconto:             number;
  obsContrib?:               string;
  itens:                     NfceItemRequest[];
  formasPagamento:           NfcePagamentoRequest[];
}

export interface EmitirNfceResponse {
  sucesso:           boolean;
  cStat:             string | null;
  xMotivo:           string | null;
  protocolo:         string | null;
  chaveNota:         string | null;
  qrCode:            string | null;
  urlConsulta:       string | null;
  notaEletronicaId:  number;
  numeroNota:        number;
  contingencia?:     boolean;
}

export interface CancelarNfceRequest {
  justificativa: string;
}

export interface NfceListItem {
  id:                number;
  numeroNota:        number;
  serie:             string | null;
  dtEmissao:         string;
  nomeConsumidor:    string | null;
  cnpjCpfConsumidor: string | null;
  totalNota:         number;
  chaveAcesso:       string | null;
  protocolo:         string | null;
  isCancelado:       boolean;
  isFaturado:        boolean;
}

export interface NfceListResponse {
  total:   number;
  pagina:  number;
  tamanho: number;
  items:   NfceListItem[];
}

export interface NfceDetalhe {
  id:                 number;
  numeroNota:         number;
  serie:              string | null;
  dtEmissao:          string;
  dtAutorizacao:      string | null;
  naturezaOperacao:   string | null;
  isAmbienteProducao: boolean;
  nomeConsumidor:     string | null;
  cnpjCpfConsumidor:  string | null;
  emailConsumidor:    string | null;
  indicadorPresenca:  number;
  totalProdutos:      number;
  totalNota:          number;
  valorDesconto:      number;
  chaveAcesso:        string | null;
  protocolo:          string | null;
  qrCode:             string | null;
  urlConsulta:        string | null;
  isFaturado:         boolean;
  isCancelado:        boolean;
}

export interface ProximoNumeroNfce {
  proximoNumero: number;
  serie:         string;
}
